export default __webpack_public_path__ + "static/Overpass-ExtraBold-6dfa2ad7fe7069452b273b2fd92b170a.woff2";